import { useCallback } from "react";
import api from "@/utils/connector/ApiConnector";
import { Client } from "@/utils/models/Client";

export interface CustomerFilters {
  query?: string;
  hasAffiliate?: 'true' | 'false' | '';
  dateFrom?: string;
  dateTo?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export function useCustomers() {
  // Retorna uma função para buscar clientes paginados
  const fetchCustomers = useCallback(async (
    token: string, 
    page: number, 
    pageSize: number, 
    filters?: CustomerFilters
  ) => {
    const resp = await api.get("/customer", {
      params: {
        page,
        pageSize,
        query: filters?.query || undefined,
        hasAffiliate: filters?.hasAffiliate || undefined,
        dateFrom: filters?.dateFrom || undefined,
        dateTo: filters?.dateTo || undefined,
        sortBy: filters?.sortBy || undefined,
        sortOrder: filters?.sortOrder || undefined,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    const raw = (resp && (resp as any).data) ? (resp as any).data : resp;
    const clientsArray = Array.isArray(raw.items) ? raw.items : [];
    const normalized = clientsArray.map((c: any) => ({ ...c, customerId: c.id }));
    return { clients: normalized as Client[], total: raw.total || 0 };
  }, []);

  return { fetchCustomers };
}
